import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const tenant = JSON.parse(localStorage.getItem('tenant') || '{}');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // 增强日志，完整打印请求信息
    const fullUrl = `${config.baseURL || ''}${config.url}`;
    console.log(`📢 前端API请求: [${config.method?.toUpperCase()}] ${fullUrl}`, { 
      完整URL: fullUrl,
      请求方法: config.method?.toUpperCase(),
      baseURL: config.baseURL,
      path: config.url,
      是否有token: !!token,
      token长度: token?.length || 0,
      token前缀: token ? token.substring(0, 10) + '...' : 'N/A',
      租户ID: tenant?.id || '未设置',
      请求头: config.headers
    });
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('✉️ 已添加认证头到请求');
    } else {
      console.log('⚠️ 请求未携带认证信息');
    }

    // 添加租户ID请求头（两种格式都支持）
    if (tenant && tenant.id) {
      config.headers['X-Tenant-ID'] = tenant.id;
      config.headers['X-Tenant-Id'] = tenant.id;
      console.log(`✉️ 已添加租户ID到请求: ${tenant.id}`);
    } else {
      console.log('⚠️ 请求未携带租户ID');
    }

    // 为企微相关的API添加用户ID（如果需要）
    if (config.url && config.url.includes('/wework/')) {
      console.log('🔍 检测到企微相关API请求');
      
      // 添加用户ID（如果存在）
      if (user && user.id) {
        config.headers['X-User-Id'] = user.id.toString();
        console.log(`✉️ 已添加用户ID到请求: ${user.id}`);
      }

      // 验证必需的请求头
      const requiredHeaders = ['X-Tenant-Id'];
      const missingHeaders = requiredHeaders.filter(header => !config.headers[header]);
      
      if (missingHeaders.length > 0) {
        console.error('❌ 企微API请求缺少必需的请求头:', missingHeaders);
        console.error('🔧 当前localStorage状态:', {
          tenant: tenant,
          user: user
        });
      } else {
        console.log('✅ 企微API请求头检查通过');
      }
    }
    
    return config;
  },
  (error) => {
    console.error('❌ 请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器处理错误
api.interceptors.response.use(
  (response) => {
    // 详细记录响应信息
    console.log(`📩 API响应成功 [${response.status}] ${response.config.url}`, {
      URL: response.config.url,
      方法: response.config.method?.toUpperCase(),
      状态码: response.status,
      数据类型: typeof response.data,
      数据结构: Array.isArray(response.data) ? '数组' : (typeof response.data === 'object' ? '对象' : '其他类型'),
      数据字段: typeof response.data === 'object' ? Object.keys(response.data) : '非对象',
      数据样例: Array.isArray(response.data) && response.data.length > 0 ? 
        Object.keys(response.data[0] || {}) : '数组为空或非数组',
      数据大小: JSON.stringify(response.data)?.length || 0
    });
    
    // 如果路径包含executions，打印更详细信息便于调试
    if (response.config.url.includes('executions')) {
      console.log('🔍 SOP执行记录数据结构:', response.data);
      
      // 如果是数组，打印第一个元素的结构
      if (Array.isArray(response.data) && response.data.length > 0) {
        console.log('📋 第一条执行记录字段:', response.data[0]);
      } 
      // 如果是带有records的对象
      else if (response.data && response.data.records && Array.isArray(response.data.records) && response.data.records.length > 0) {
        console.log('📋 第一条执行记录字段:', response.data.records[0]);
      }
    }
    
    return response;
  },
  (error) => {
    // 详细记录错误信息
    console.error(`❌ API错误 [${error.response?.status || 'NETWORK_ERROR'}]`, {
      URL: error.config?.url,
      方法: error.config?.method?.toUpperCase(),
      状态码: error.response?.status,
      错误消息: error.response?.data || error.message,
      详细错误: error.response?.data
    });
    // 将后端返回的 message 透传到前端错误对象，便于统一展示
    try {
      const backendMessage = error?.response?.data?.message || error?.response?.data?.msg;
      if (backendMessage && typeof backendMessage === 'string') {
        error._originalMessage = error.message;
        error.message = backendMessage;
      }
    } catch (_) {}
    
    // 处理401错误（未授权）
    if (error.response && error.response.status === 401) {
      console.error('🚫 认证失效 [401]，清除认证信息');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tenant');
      localStorage.removeItem('authType');
      localStorage.removeItem('isAdmin');
      window.location.href = '/';
    }
    
    return Promise.reject(error);
  }
);

export default api; 